import { useQuery } from '@tanstack/react-query';
import type { PaginationResponse } from 'scheduler-types';
import type { OrderListItem } from './useOrders';
import { apiFetch } from '../lib/api';

interface PriorityListResponse {
  data: OrderListItem[];
  pagination: PaginationResponse;
}

async function fetchPriorityList(): Promise<PriorityListResponse> {
  // Fetch active orders - they come sorted by priority from the API
  return apiFetch<PriorityListResponse>('/api/v1/orders?status=active&limit=100');
}

export function usePriorityList() {
  return useQuery({
    queryKey: ['priority-list'],
    queryFn: fetchPriorityList,
    staleTime: 30000,
  });
}
